<template>
    <el-dialog v-model="dialog_opened" width="90%" :before-close="close">
        <el-row v-loading="loading">
            <el-col :span="11">
                <div class="canvas" id="canvas">
                    <img :src="image.origin_svg?`https://color-cdn.rabigame.com/${image.origin_svg}`:''" style="width: 100%" v-if="image" id="fore">
                    <canvas ref="canvas" class="layer" v-loading="loading"></canvas>
                    <img id="area" class="layer">
                </div>
            </el-col>
            <el-col :span="2" style="text-align: center;">
                <el-divider direction="vertical" style="height: 100%"></el-divider>
            </el-col>
            <el-col :span="11" v-if="data">
                <el-switch v-model="small" :inactive-value="false" :active-value="true" inactive-text="不显示"
                           active-text="显示小色块" @change="changeSmall"></el-switch>
                <p>共 {{ data.colorGroup.length }} 种颜色；共 {{ Object.keys(data.cells).length }} 个色块。</p>
                <div>
                    <div v-for="g in data.colorGroup" class="circle" @click="fillColor(g)" :class="g.active?'active':''"
                         :style="{backgroundColor: g.color, color: calColor(g.color)}">
                        {{ g.regions.length }}
                    </div>
                </div>
            </el-col>
        </el-row>
        <template #footer>
            <el-button type="primary" @click="close">关闭</el-button>
        </template>
    </el-dialog>
</template>

<script>
import animationData from "./assets/marker.json";
import lottie from "lottie-web";
import {loadMap} from "./utils/mapLoad";

export default {
    name: "Test",
    data() {
        return {
            loading: false, dialog_opened: false, mask: null, small: false, image: null, data: null, worker: null,
            _mapRevoke: null, _mapLoadGen: 0,
        }
    },
    methods: {
        async init(image) {
            const gen = ++this._mapLoadGen;
            if (this._mapRevoke) {
                this._mapRevoke();
                this._mapRevoke = null;
            }
            this.dialog_opened = this.loading = true;
            this.image = image;
            try {
                const {data, maskSrc, revoke} = await loadMap(image._id, {lite: true});
                if (gen !== this._mapLoadGen) {
                    revoke();
                    return;
                }
                this._mapRevoke = revoke;
                this.data = data;
                this.data.colorGroup.forEach(g => {
                    g.active = false;
                });
                const canvas = this.$refs.canvas;
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                const img = new Image();
                img.src = maskSrc;
                img.onload = _ => {
                    if (gen !== this._mapLoadGen) return;
                    this.mask = document.createElement('canvas');
                    const ctx = this.mask.getContext('2d');
                    this.mask.width = canvas.width = img.width;
                    this.mask.height = canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    const parent = document.getElementById('canvas');
                    parent.style.height = parent.clientWidth / canvas.width * canvas.height + 'px';
                };
            } catch (e) {
                if (gen === this._mapLoadGen) console.error(e);
            } finally {
                if (gen === this._mapLoadGen) this.loading = false;
            }
        },
        close() {
            this._mapLoadGen++;
            this.cleanMarker();
            if (this._mapRevoke) {
                this._mapRevoke();
                this._mapRevoke = null;
            }
            this.dialog_opened = this.loading = this.small = false;
            this.$nextTick(_ => {
                this.image = this.mask = this.data = null;
                this.zoom = 1;
            });
        },
        calColor(color) {
            const r = parseInt(color.slice(1, 3), 16);
            const g = parseInt(color.slice(3, 5), 16);
            const b = parseInt(color.slice(5, 7), 16);
            return r * 0.299 + g * 0.587 + b * 0.144 >= 128 ? '#606266' : '#EBEEF5';
        },
        drawCircle(cell) {
            const canvas = this.$refs.canvas;
            const fore = document.getElementById('fore');
            const width = fore.parentElement.clientWidth;
            const height = fore.parentElement.clientHeight;
            const marker = document.createElement('div');
            marker.className = 'marker mask-marker';
            marker.style.position = 'absolute';
            marker.style.zIndex = '999';
            const x = cell.textPos[0] + cell.topLeft[0];
            const y = cell.textPos[1] + cell.topLeft[1];

            const canvas_width = canvas.width;
            const canvas_height = canvas.height;
            marker.style.left = (x / canvas_width * width - 50) + 'px';
            marker.style.top = (y / canvas_height * height - 50) + 'px';
            marker.style.width = '100px';
            lottie.loadAnimation({
                container: marker,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                animationData,
            });
            canvas.insertAdjacentElement('afterend', marker);
        },
        cleanMarker() {
            document.querySelectorAll('.mask-marker').forEach(e => {
                e.parentElement.removeChild(e);
            });
        },
        changeSmall() {
            this.cleanMarker();
            this.data.colorGroup.forEach(g => {
                g.active = false;
            });
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            if (this.small) {
                const ctx1 = this.mask.getContext('2d');
                const map_data = ctx1.getImageData(0, 0, canvas.width, canvas.height).data;
                const data = ctx.getImageData(0, 0, canvas.width, canvas.height);
                Object.keys(this.data.cells).forEach(k => {
                    const cell = this.data.cells[k];
                    if (cell.textSize < 18 && cell.width < 50 && cell.height < 50) {
                        this.drawCircle(cell);
                        for (let i = 0; i < data.data.length; i += 4) {
                            if (map_data[i] === (k >> 16) % 256 && map_data[i + 1] === (k >> 8) % 256 && map_data[i + 2] === k % 256) {
                                data.data[i] = cell.avgColor[0];
                                data.data[i + 1] = cell.avgColor[1];
                                data.data[i + 2] = cell.avgColor[2];
                                data.data[i + 3] = 255;
                            }
                        }
                    }
                });
                ctx.putImageData(data, 0, 0);
            }
        },
        fillColor(group) {
            this.data.colorGroup.forEach(g => {
                g.active = false;
            });
            this.cleanMarker();
            group.active = true;
            if (this.small) {
                this.small = false;
                this.changeSmall();
            }
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            const ctx1 = this.mask.getContext('2d');
            const map_data = ctx1.getImageData(0, 0, canvas.width, canvas.height).data;
            const data = ctx.getImageData(0, 0, canvas.width, canvas.height);

            group.regions.forEach(r => {
                for (let i = 0; i < data.data.length; i += 4) {
                    if (map_data[i] === (r >> 16) % 256 && map_data[i + 1] === (r >> 8) % 256 && map_data[i + 2] === r % 256) {
                        data.data[i] = parseInt(group.color.slice(1, 3), 16);
                        data.data[i + 1] = parseInt(group.color.slice(3, 5), 16);
                        data.data[i + 2] = parseInt(group.color.slice(5, 7), 16);
                        data.data[i + 3] = 255;
                    }
                }
                const cell = this.data.cells[r + ''];
                if (cell.textSize < 20 && cell.width < 50 && cell.height < 50) {
                    this.drawCircle(cell);
                }
            });

            ctx.putImageData(data, 0, 0);
        }
    },
}
</script>

<style scoped>
.canvas {
    position: relative;
    background-color: #FFF;
    overflow: hidden;
}

.layer {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
}

.circle {
    width: 40px;
    height: 40px;
    margin: 5px;
    border-radius: 50%;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    font-weight: bold;
    display: inline-block;
}

.circle.active {
    font-size: 18px;
    margin: 0;
    border: 5px solid var(--el-color-primary);
}
</style>